"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.mapDispatchToCaseCancellationProps = exports.mapStateToCaseCancellationProps = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var cancelInvoicesConfirm = ui_common_1.codeBenchActions.cancelInvoicesConfirm, cancelInvoicesDismiss = ui_common_1.codeBenchActions.cancelInvoicesDismiss;
var mapStateToCaseCancellationProps = function (state) {
    return __assign(__assign(__assign({}, state.codeBench), state.ampUI), { cursorAPIContext: __assign({}, state.capabilities.cursorAPIContext) });
};
exports.mapStateToCaseCancellationProps = mapStateToCaseCancellationProps;
var mapDispatchToCaseCancellationProps = function (dispatch) {
    return {
        onCaseCancelDismiss: function (ev) {
            dispatch(cancelInvoicesDismiss());
        },
        onCaseCancel: function (submission) {
            dispatch(cancelInvoicesConfirm(submission));
        }
    };
};
exports.mapDispatchToCaseCancellationProps = mapDispatchToCaseCancellationProps;
//# sourceMappingURL=case-cancellation-component-utilities.js.map